import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { connect } from "react-redux";
import React, { Component } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { bindActionCreators } from "redux";
import * as movieActions from "../../redux/actions/movieActions";
import * as detailActions from "../../redux/actions/detailsActions";
import "../slider/slider.css";
import { Link } from "react-router-dom";
class ImgSlider extends Component {
  state = { count: 2, genres: [], obj: false };
  checkCount() {
    var timeleft = 2;
    var text = document.querySelector(".trend-text");
    var downloadTimer = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
        text.style.opacity = "1";
      } else {
        timeleft -= 1;
        console.log(timeleft);
        this.setState({ count: this.state.count - 1 });
      }
    }, 1000);
  }
  componentDidMount() {
    this.props.actions.getTopMovies();
    this.checkCount();
  }
  movieDetail(movieId) {
    localStorage.setItem("id", movieId);
    this.props.actions.getChoosenMovie(parseInt(localStorage.getItem("id")));
  }
  renderPart() {
    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 2,
      autoplay: true,
    };
    return (
      <Carousel {...settings}>
        {this.props.topMovies.map((movie) => (
          <Wrap key={movie.id}>
            <div style={{ margin: "6px" }}>
              <Link onClick={() => this.movieDetail(movie.id)} to={`/movie/${movie.id}`} onContextMenu={() => this.movieDetail(movie.id)}>
                <LazyLoadImage
                  className="slider-img"
                  alt={movie.title}
                  src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`}
                  key={movie.poster_path}
                ></LazyLoadImage>
              </Link>
            </div>
          </Wrap>
        ))}
      </Carousel>
    );
  }
  
  renderEmpty() {
    return (
      <div className="ringg">
        <div className="img2 text-center">
          <div className="ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div className="sliderr">
        <h3
          className="text-light trend-text"
          style={{
            marginBottom: "-60px",
            marginTop: "50px",
            marginLeft: "10px",
            opacity: "0",
            transition: "0.3s",
          }}
          
        >
          
          Trendings
        </h3>
        <div id="movies">
        {this.state.count < 1 ? this.renderPart() : this.renderEmpty()}
        </div>
        
        
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    topMovies: state.topMoviesReducer,
    choosenMovie: state.detailReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      getTopMovies: bindActionCreators(movieActions.getTopMovies, dispatch),
      getChoosenMovie: bindActionCreators(detailActions.getMovie, dispatch),
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ImgSlider);

const Carousel = styled(Slider)`
  width: 100%;
  margin: auto;
  margin-top: 100px;
  height: 300px;

  & > button {
    opacity: 1;
    height: 100%;
    width: 5vw;
    z-index: 1;
    &:hover {
      opacity: 1;
      transition: opacity 0.3s ease 0s;
    }
  }
  ul li button {
    &:before {
      font-size: 10px;
      color: rgb(150, 158, 171);
    }
  }
  li.slick-active button:before {
    color: white;
    font-size: 10px;
  }
  .slick-next:before {
    font-size: 50px;
    @media only screen and (max-width: 768px) {
      font-size: 35px;
    }
  }

  .slick-prev:before {
    font-size: 50px;
    @media only screen and (max-width: 768px) {
      font-size: 35px;
    }
  }
  .slick-list {
    overflow: initial;
    width: 650px;
    border-radius: 1rem;
    @media only screen and (max-width: 768px) {
      width: 420px;
    }
  }

  .slick-prev {
    left: 30px;
    @media only screen and (max-width: 768px) {
      top: 100px;
      left: 10px;
    }
  }
  .slick-next {
    right: 30px;
    @media only screen and (max-width: 768px) {
      top: 100px;
      right: 20px;
    }
  }
`;

const Wrap = styled.div`
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  div {
    border-radius: 4px;
    border-radius: 1rem;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
      rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    cursor: pointer;
    display: block;
    position: relative;
    padding: 4px;
    img {
      width: 196px;
      height: 330px;
      border-radius: 1rem;
      @media only screen and (max-width: 768px) {
        width: 120px;
        height: 200px;
      }
    }
    &:hover {
      padding: 0;
      border: 4px solid rgba(249, 249, 249, 0.8);
      transition-duration: 300ms;
    }
  }
`;
